<template>
  <div class="card width-960 modal-hauteur-65vh">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">{{ $t('detail.popUpEnvoieDemandeSignature.title')}}</h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component
        :messages="messages"
        :error="error"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="error = false"/>
      <div class="has-text-weight-bold is-size-5 has-text-default">
        {{ $t('detail.popUpEnvoieDemandeSignature.donneurdOrde') }}
      </div>
      <div class="columns is-multiline">
        <div class="column is-6">
          <router-link-blank
            classMessage="has-text-weight-bold lien mgr-5px is-size-5"
            :to="{ name: 'c.bodac.clients/contacts-client',
              params: {id: donneurDordre.tiersId}}"
            :message="donneurDordre.nomCommercial"/>
          <p class="is-italic  has-text-default">
            {{ $t('detail.popUpEnvoieDemandeSignature.adresse') }}
          </p>
          <p> {{ donneurDordre.adressePostale.intitule2 }} </p>
          <p> {{ donneurDordre.adressePostale.intitule3 }} </p>
          <p>{{ donneurDordre.adressePostale.adresse1 }}</p>
          <p v-if="donneurDordre.adressePostale.adresse2">
            {{ donneurDordre.adressePostale.adresse2 }}
          </p>
          <p>
            {{ donneurDordre.adressePostale.codePostal }}
            <span v-if="donneurDordre.adressePostale.codePostal
                  && donneurDordre.adressePostale.ville">
                    -
                  </span>
            {{ donneurDordre.adressePostale.ville }}
          </p>
          <p>{{ donneurDordre.adressePostale.pays }}</p>
        </div>
        <div class="column is-6">
          <p class="is-italic">
            {{ $t('detail.popUpEnvoieDemandeSignature.telephonePortable') }}
          </p>
          <p class="has-text-weight-bold">{{ donneurDordre.tiers.portable }}</p>
          <p class="is-italic">{{ $t('detail.popUpEnvoieDemandeSignature.email') }}</p>
          <p class="lien has-text-weight-bold">{{ donneurDordre.tiers.email }}</p>
        </div>
      </div>
      <div class="tab is-marginless">
        <ul>
          <li :class="{'is-active': activeTab === 'contacts'}"
              @click="activeTab = 'contacts'">
            {{ $t('detail.popUpEnvoieDemandeSignature.contacts') }}
          </li>
          <li :class="{'is-active': activeTab === 'transaction'}" v-if="displayTransaction"
              @click="activeTab = 'transaction'">
            {{ $t('detail.popUpEnvoieDemandeSignature.transaction') }}
          </li>
        </ul>
      </div>
      <div class="displayNonePagination" v-if="activeTab === 'contacts'">
        <v-client-table
          v-model="contacts"
          :columns="columns"
          :options="options"
          class="mgt-20px">
          <div slot="selected" slot-scope="props" class="is-pulled-right">
            <qd-radio
              v-model="contactId"
              size="is-small"
              :native-value="props.row.id"
              :disabled="hasStopSignatureEnCours || hasSigned">
            </qd-radio>
          </div>
          <template slot="nom" slot-scope="props">
            <router-link-blank
              :to="{ name: 'c.bodac.clients/contacts-contacts', params: {id: props.row.id} }"
              classMessage="lien"
              :message="props.row.nom">
            </router-link-blank>
          </template>
          <template slot="prenom" slot-scope="props">
            {{props.row.prenom}}
          </template>
          <template slot="service" slot-scope="props">
            {{props.row.service}}
          </template>
          <template slot="fonction" slot-scope="props">
            {{props.row.fonction}}
          </template>
          <template slot="telephone" slot-scope="props">
            {{props.row.telephone}}
          </template>
          <template slot="portable" slot-scope="props">
            {{props.row.portable}}
          </template>
          <template slot="email" slot-scope="props">
            {{props.row.email}}
          </template>
        </v-client-table>
      </div>
      <tab-liste-signature-histo
        v-if="activeTab === 'transaction'"
        class="mgt-20px displayNonePagination"
        :signatures="devisCommande.signaturesHisto">
      </tab-liste-signature-histo>
      <div v-if="!hasStopSignatureEnCours && !hasSigned">
        <b-upload
          v-model="piecesJointes"
          multiple
          drag-drop
          accept=".pdf"
          class="mgv-20px"
          :disabled="hasStopSignatureEnCours || hasSigned">
          <div class="content">
            <div class="mg-5px">
              <b-icon icon="upload" type="is-primary" size="is-small"></b-icon>
              <span>{{ $t('detail.popUpEnvoieDemandeSignature.ajouterPj') }}</span>
            </div>
          </div>
        </b-upload>
        <span class="has-text-danger mgl-10px">
          {{ $t('detail.popUpEnvoieDemandeSignature.pdfOnly') }}
        </span>
      </div>
      <div class="columns is-multiline">
        <div class="column is-3"
          v-for="(pj, index) in piecesJointes" :key="index">
          <div class="card">
            <div class="card-content level">
              <div class="level-left">
                <b-icon icon="file-document" type="is-default"></b-icon>
                <span class="mgl-10px ellipsis width-100">{{ pj.name }}</span>
              </div>
              <div class="level-right is-cursor-pointer" @click="deletePieceJointe(pj)">
                <b-icon icon="delete" type="is-danger"></b-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mgt-20px">
        <div class="is-pulled-left boutonAction">
          <a class="button" @click="$parent.close">
            {{ $t('general.button.cancel') }}
          </a>
        </div>
        <b-tooltip
          :active="hasSigned"
          :label="$t('detail.dcfSignable.dejaSigne')"
          position="is-left">
          <div class="is-pulled-left boutonAction" v-if="hasStopSignatureEnCours">
            <qd-button
              class="is-primary"
              @click="closeDemandeSignature">
              {{ $t('detail.popUpEnvoieDemandeSignature.stopperActionSignature') }}
            </qd-button>
          </div>
          <div class="is-pulled-left boutonAction" v-else>
            <qd-button
              class="is-primary"
              @click="envoyerDemandeSignature"
              :class="[{'disabledButton': hasSigned}]"
              :disabled="hasSigned">
              {{ $t('general.button.send') }}
            </qd-button>
          </div>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { sendSignature, stopActionSignature } from '@/api/signatureElectronique';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  TEXTS, RESULTS_PER_POP_UP, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import { getAllByTiers } from '@/api/contacts';
import {
  OPENNED,
  ARCHIVED,
  SIGNED,
  CANCELED,
} from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import checkSiSignableCommun from '@/services/devisCommandes/signatureElectronique/checkSiSignableCommun';
import tabListeSignatureHisto from '@/components/devisCommandes/detailDevisCommande/tabListeSignatureHisto';
import validation from '@/services/signatureElectronique/validation/validation';

export default {
  props: {
    devisCommande: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    routerLinkBlank,
    tabListeSignatureHisto,
  },
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      contactId: null,
      contacts: [],
      piecesJointes: [],
      activeTab: 'contacts',
    };
  },
  computed: {
    donneurDordre() {
      return this.devisCommande.intervenants.find(el => el.donneurOrdre);
    },
    columns() {
      return ['selected', 'nom', 'prenom', 'service', 'fonction', 'telephone', 'portable', 'email'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          selected: '',
          nom: this.$i18n.t('detail.popUpEnvoieDemandeSignature.tabs.nom'),
          prenom: this.$i18n.t('detail.popUpEnvoieDemandeSignature.tabs.prenom'),
          service: this.$i18n.t('detail.popUpEnvoieDemandeSignature.tabs.service'),
          fonction: this.$i18n.t('detail.popUpEnvoieDemandeSignature.tabs.fonction'),
          telephone: this.$i18n.t('detail.popUpEnvoieDemandeSignature.tabs.telephone'),
          portable: this.$i18n.t('detail.popUpEnvoieDemandeSignature.tabs.portable'),
          email: this.$i18n.t('detail.popUpEnvoieDemandeSignature.tabs.email'),
        },
        sortable: [],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        columnsClasses: {
          selected: 'colonneSelected',
        },
      };
    },
    hasStopSignatureEnCours() {
      return this.devisCommande.signaturesHisto
        .filter(el => el.contratEtatSignature === OPENNED).length === 1;
    },
    hasSigned() {
      return this.devisCommande.signaturesHisto.some(s => s.contratEtatSignature === ARCHIVED
        || s.contratEtatSignature === SIGNED);
    },
    displayTransaction() {
      return this.devisCommande.signaturesHisto.length
        && this.devisCommande.signaturesHisto.every(s => s.contratEtatSignature === CANCELED);
    },
  },
  methods: {
    async envoyerDemandeSignature() {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      this.error = false;
      const contact = this.contacts.find(el => el.id === this.contactId);
      checkSiSignableCommun(contact, this.messages);
      this.error = this.messages.length > 0;
      if (this.error) return;

      const loadingComponent = this.$buefy.loading.open();
      try {
        const data = new FormData();
        if (this.piecesJointes) {
          this.piecesJointes.forEach((file) => {
            data.append(file.name, file, file.name);
          });
        }
        const params = {
          referenceId: this.devisCommande.id,
          referenceType: this.devisCommande.type,
          contactId: this.contactId,
        };
        data.append('signatureInput', JSON.stringify(params));
        await sendSignature(data);
        loadingComponent.close();
        messageSucces(this.$t('detail.popUpEnvoieDemandeSignature.messages.demandeSignatureSucces'));
        this.$router.go(0);
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async closeDemandeSignature() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.error = false;
        await stopActionSignature(this.devisCommande.id);
        loadingComponent.close();
        messageSucces(this.$t('detail.popUpEnvoieDemandeSignature.messages.closeDemandeSignatureSucces'));
        this.$router.go(0);
        return;
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    deletePieceJointe(pj) {
      const index = this.piecesJointes.indexOf(pj);
      this.piecesJointes.splice(index, 1);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.contacts = (await getAllByTiers(this.donneurDordre.tiersId)).data.result.items;
      if (this.hasStopSignatureEnCours) {
        this.contactId = this.devisCommande.signaturesHisto
          .find(el => el.contratEtatSignature === OPENNED).contactId;
      } else if (this.hasSigned) {
        this.contactId = this.devisCommande.signaturesHisto
          .find(el => el.contratEtatSignature === ARCHIVED
            || el.contratEtatSignature === SIGNED).contactId;
      } else this.contactId = this.donneurDordre.contactId;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
